import { type ChatMessageDto, parseMonitorEventText } from "@/lib/chat";
import { extractContentText } from "@/lib/message-controls";

/**
 * チャットメッセージ列から monitorEvent を monitor_id ごとの出力行にまとめる。
 * 各 monitorEvent の本文 (JSON エンベロープ) を解き、monitor_id が判る行だけを蓄積する。
 * 停止・終了の通知も同じエンベロープで届くため、そのままログ末尾に載る。
 */
export function groupMonitorLogs(messages: ChatMessageDto[]): Map<string, string[]> {
	const logsByMonitor = new Map<string, string[]>();
	for (const message of messages) {
		if (message.role !== "monitorEvent") continue;
		const { monitorId, content } = parseMonitorEventText(extractContentText(message.content));
		if (monitorId === null) continue;
		const lines = logsByMonitor.get(monitorId) ?? [];
		for (const line of content.split("\n")) {
			lines.push(line);
		}
		logsByMonitor.set(monitorId, lines);
	}
	return logsByMonitor;
}
